import React from 'react';
import Udesk from 'Udesk';
import { Redirect } from 'react-router-dom';
import LayoutMenu from 'Component/common/layout-menu';
import UdeskLocales from 'UdeskLocales';
import { getCurrentRouteName } from 'Udesk/system/subApp';

class trainingCenter extends React.Component {
    isRedirect(currentPath, toPath) {
        if (currentPath === toPath) {
            return true;
        }
        return false;
    }

    render() {
        let { route, location, sdkOptions } = this.props;
        let { locales } = this;
        let navLists = [];
        // 根据当前用户权限，组装菜单列表
        //&& Udesk.data.init.user.hasFeature("smart:tag:root")
        // if (Udesk.data.init.user && Udesk.data.init.user.hasFeature('sys:module:list:root')) {
        // if (Udesk.data.init.user && Udesk.data.init.user.hasFeature('sys:data:integration:root')) {
        navLists.push({
            text: locales.menu.admin.systemIntegration.subTitle[
                Udesk.data.init.company.enabledWhiteSystem ? 'udeskWhite' : 'udesk'
            ],
            pathName: getCurrentRouteName('systemIntegrationCCpass'),
            isActive: (match, location) => {
                return location.pathname.includes('/cc-pass');
            },
        });
        navLists.push({
            text: locales.menu.admin.systemIntegration.subTitle.wechat,
            pathName: getCurrentRouteName('wechatDocking'),
            isActive: (match, location) => {
                return location.pathname.includes('/wecom');
            },
        });
        if (Udesk.data.init.company.enabledMallInspect) {
            navLists.push({
                text: locales.menu.admin.systemIntegration.subTitle.taobao,
                pathName: getCurrentRouteName('taobaoDocking'),
                isActive: (match, location) => {
                    return location.pathname.includes('/taobao');
                },
            });
        }
        navLists.push({
            text: locales.menu.admin.systemIntegration.subTitle.weifeng,
            pathName: getCurrentRouteName('weifengDocking'),
            isActive: (match, location) => {
                return location.pathname.includes('/weifeng');
            },
        });
        navLists.push({
            text: 'Zendesk',
            pathName: getCurrentRouteName('systemIntegrationZendesk'),
            isActive: (match, location) => {
                return location.pathname.includes('/zendesk');
            },
        });
        navLists.push({
            text: UdeskLocales['current'].pages.admin.customDataSource.amazonEcommerce,
            pathName: getCurrentRouteName('amazonList'),
            isActive: (match, location) => {
                return location.pathname.includes('/amazon');
            },
        });
        navLists.push({
            text: UdeskLocales['current'].pages.admin.customDataSource.youtubeVideo,
            pathName: getCurrentRouteName('youtubeList'),
            isActive: (match, location) => {
                return location.pathname.includes('/youtube');
            },
        });
        // }

        if (
            sdkOptions.props.landingPath != null &&
            this.isRedirect(route.path, location.pathname)
        ) {
            let toPath = location.pathname + sdkOptions.props.landingPath;
            return <Redirect to={toPath} sdkOptions={sdkOptions} />;
        } else if (navLists.length > 0 && this.isRedirect(route.path, location.pathname)) {
            let toPath = null;
            if (navLists[0].pathName) {
                toPath = Udesk.ui.routing.getRouteFirstBottomedChildRoutePath({
                    routeName: navLists[0].pathName,
                });
            } else {
                toPath = Udesk.ui.routing.getRouteFirstBottomedChildRoutePath({
                    routeName: navLists[0].children[0].pathName,
                });
            }

            return <Redirect to={toPath} sdkOptions={sdkOptions} />;
        } else {
            return (
                <div className="semantic-intelligence">
                    <LayoutMenu
                        {...this.props}
                        navLists={navLists}
                        menuTitle={/* 数据集成 */UdeskLocales['current'].pages.conversationAnalysis.dataIntegration.dataIntegration}
                    />
                </div>
            );
        }
    }
}

export default Udesk.react.udeskify(trainingCenter);
